<template>
  <div class="error-container">
    <slot />
  </div>
</template>

<style scoped>
.error-container {
  background: #E44C42;
  color: white;
  font-size: inherit;
  border-radius: 4px;
  padding: 1rem;
}
</style>
